import styled from 'styled-components';

import { Collapse } from 'components/ui';

import { multiSelectWiderClickableAreaStyles } from '../TableFilterMultiSelect';

export const AssetFilterInnerContainer = styled.div`
  padding: 8px;
  width: 100%;

  .ant-alert {
    margin-bottom: 0.5rem;
  }
`;

export const AssetFilterWarning = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.red};
  padding-bottom: 8px;
`;

export const AssetSelectContainer = styled.div<{ $selectWidth?: string }>`
  align-items: flex-start;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.75rem;
  width: 100%;

  > span:first-of-type {
    flex-shrink: 0;
    line-height: 32px;
    margin-right: 0.5rem;
  }

  /* Select / Tooltip wrapper column (not the label) */
  > :not(span:first-of-type) {
    ${({ $selectWidth }) => ($selectWidth ? `width: ${$selectWidth}` : 'flex: 1 1 auto')};
    max-width: calc(100% - 80px);
    min-width: 0;
  }

  .ant-select {
    width: 100%;
  }

  ${multiSelectWiderClickableAreaStyles}
`;

export const ComponentFiltersCollapse = styled(Collapse)`
  margin: 0;
  width: 100%;

  .ant-collapse-expand-icon {
    padding-inline-end: 0 !important;
  }

  .ant-collapse-content-box {
    background: ${({ theme }) => theme.secondaryBackgroundColor};
    padding: 8px !important;
  }
`;
